<template>
    <button-base styleType="warning">
        <slot></slot>
    </button-base>
</template>
